<div class="inicio">

    <form #insertForm="ngForm" [formGroup]="formsolicitudAsigEq">

        <div class="grid-container5">
            <button mat-mini-fab color="accent" matTooltip="Retornas a ver todas tus solicitudes realizadas" (click)="clickGoback()" ><mat-icon style="transform: rotate(180deg);">forward icon</mat-icon></button>
            <div></div>
            <p class="titulo">DETALLE DE SOLICITUD</p>
            <div></div>
            <div></div>  
        </div>  

        <div class="columnas_5">
            <div></div><div></div> <div></div> <div></div>  
            <mat-label>
                <mat-label class="texto-negrita">Fecha de solicitud: </mat-label>   
                <mat-label class="texto-normal" >{{formsolicitudAsigEq.value.fecha_de_solicitud}}</mat-label>
            </mat-label>

            <div></div><div></div> <div></div> <div></div>  
            <mat-label>
                <mat-label class="texto-negrita">Última modificación: </mat-label>   
                <mat-label class="texto-normal" >{{formsolicitudAsigEq.value.fecha_ultima_modificacion}}</mat-label>
            </mat-label>
        </div>

        <br>

        <div class="columnas_2___filas_1">
            
            <div class="fondo">
                <div class="columna_1___filas_4">
                    
                    <mat-label class="subtitulo">DATOS DEL EMPLEADO SOLICITADO</mat-label>
                    
                    <div class="celda">
                        <br><br>
                        <mat-label class="texto-negrita">Nombre:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.colaborador}}</mat-label>
                    </div>
                    
                    <div class="celda">
                        <br>
                        <mat-label class="texto-negrita">Cargo:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.colacargo}}</mat-label>
                    </div>
    
                    <div class="celda">
                        <br>
                        <mat-label class="texto-negrita">Oficina:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.colasucursal}}</mat-label>
                    </div>
                </div>
            </div>

            <div class="fondo">
                <div class="columna_1___filas_4">
                    <mat-label class="subtitulo">DATOS DEL SOLICITANTE </mat-label>

                    <div class="celda">
                        <br><br>
                        <mat-label class="texto-negrita">Nombre:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.solicitante}}</mat-label>
                    </div>
                    
                    <div class="celda">
                        <br>
                        <mat-label class="texto-negrita">Cargo:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.solicargo}}</mat-label>
                    </div>
    
                    <div class="celda">
                        <br>
                        <mat-label class="texto-negrita">Oficina:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.solisucursal}}</mat-label>
                    </div>
                </div>
            </div>

            
            

        </div>

        <div class="columnas_1___filas_1">
            <div class="fondo">
                <mat-label class="subtitulo" style="padding-left: 5%;">DATOS DE LA SOLICITUD</mat-label>
                <div class="columnas_2___filas_2">
                    <div class="celda">
                        <br><br>
                        <mat-label class="texto-negrita">Equipo solicitado:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.equipo_solicitado}}</mat-label>
                    </div>
                    <div class="celda">
                        <br><br>
                        <mat-label class="texto-negrita">Fecha límite de asignación:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.fecha_planeada_asignacion}}</mat-label>
                    </div>
                    <div class="celda">
                        <br><br>
                        <mat-label class="texto-negrita">Uso o descripción del equipo solicitado:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.descripcion}}</mat-label>
                    </div>
                    <div class="celda">
                        <br><br>
                        <mat-label class="texto-negrita">Comentarios y observaciones:</mat-label>
                        <mat-label class="texto-normal">{{formsolicitudAsigEq.value.Comentarios}}</mat-label>
                    </div>
                    <div class="celda">
                        <br>
                        <mat-label class="texto-negrita"> Estado actual: </mat-label>
                        <mat-label class="texto-normal">{{solicitud_detalle.status_solicitud}}</mat-label>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="columnas_3">
            <div></div><button mat-raised-button  matTooltip="Al dar click en este botón,  se inicia el proceso para cancelar la solicitud" *ngIf="habilitarBtnCancelar" color="warn" (click)="clickCancelararSolicitud()">Cancelar<mat-icon>cancel</mat-icon></button><div></div>
        </div>

    </form>

</div>